export const grid = () => ({
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    gridColumnGap: 16,
    alignItems: 'flex-start',
});
